import React, {ReactElement} from "react";
import Item from "../Model/Item";
import ItemView from "./ItemView";
import { GRID_SIZE } from "../constants";
import Star from "./Star";

interface Props {
    items: Item[],
}
const Grid: (props: Props) => ReactElement = (props: Props): ReactElement => {
    const { items } = props

    return <div className="grid-container">
        {items.map((item: Item, index: number): ReactElement => {
            return <>
                <ItemView key={item.id} item={item}/>
                {
                    index === Math.floor(GRID_SIZE ** 2 / 2) -1
                        ? <Star />
                        : null
                }
            </>
        })}
    </div>
}

export default Grid;